function initVideoBanner() {
    const video = document.getElementById('video_banner_customVideo_id');
    if (!video) return;
    const playIcon = document.getElementById('slideshow__video-action-play');
    const pauseIcon = document.getElementById('slideshow__video-action-pause');
    const soundOnIcon = document.getElementById('slideshow__icon-sound-on');
    const soundOffIcon = document.getElementById('slideshow__icon-sound-off');
    let isUserPaused = false;
    // Set once the browser refuses an automatic play; only a user click retries after that.
    let autoplayBlocked = false;
    let pendingPlay = null;

    function setDisplay(element, visible) {
        if (element) element.style.display = visible ? 'block' : 'none';
    }

    function updatePlayButton() {
        setDisplay(playIcon, video.paused);
        setDisplay(pauseIcon, !video.paused);
    }

    // Every play attempt goes through here so play() rejections are always handled and never overlap.
    function requestPlay(userInitiated) {
        if (pendingPlay) return pendingPlay;
        if (!userInitiated && autoplayBlocked) return Promise.resolve(false);

        let attempt;
        try {
            attempt = video.play();
        } catch (error) {
            attempt = Promise.reject(error);
        }
        pendingPlay = Promise.resolve(attempt)
            .then(() => {
                autoplayBlocked = false;
                return true;
            }, (error) => {
                // AbortError only means a pause() interrupted the request, not that playback is blocked.
                if (!userInitiated && (!error || error.name !== 'AbortError')) autoplayBlocked = true;
                return false;
            })
            .then((played) => {
                pendingPlay = null;
                updatePlayButton();
                return played;
            });
        return pendingPlay;
    }

    window.play_pause_button = function () {
        if (video.paused) {
            isUserPaused = false;
            requestPlay(true);
        } else {
            isUserPaused = true;
            video.pause();
        }
        updatePlayButton();
    };

    window.sound_button = function () {
        video.muted = !video.muted;
        setDisplay(soundOnIcon, !video.muted);
        setDisplay(soundOffIcon, video.muted);
    };

    video.muted = true;
    updatePlayButton();
    setDisplay(soundOnIcon, false);
    setDisplay(soundOffIcon, true);
    requestPlay(false);

    let throttleTimeout = null;
    window.addEventListener('scroll', () => {
        if (!throttleTimeout) {
            throttleTimeout = setTimeout(() => {
                const rect = video.getBoundingClientRect();
                const inView = rect.top < window.innerHeight && rect.bottom > 0;
                if (!inView && !video.paused) {
                    video.pause();
                    updatePlayButton();
                } else if (inView && video.paused && !isUserPaused) {
                    requestPlay(false);
                }
                throttleTimeout = null;
            }, 100);
        }
    });

    video.addEventListener('play', updatePlayButton);
    video.addEventListener('pause', updatePlayButton);
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVideoBanner);
} else {
    initVideoBanner();
}
